import { storeAPI } from '../config';
import type { StoreWithOpeningHours } from '../model/types';
import * as api from './';

export async function getStoreDetails(storeId: string) {
    return await api.getAnonymously<StoreWithOpeningHours>(storeAPI.storeURL(storeId), { fields: 'FULL' });
}
